<template>
  <div class="row">
    <!-- Map -->
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-12">
          <!-- :cell-style="tableHeaderColor" -->
          <el-table
            :data="tickets"
           :header-cell-style="{
                background: 'transparent',
                border: 'transparent',
                'padding-bottom': '0%',
                'padding-center': '10px',
                color: 'white',
              }"
              :cell-style="{
                border: 'transparent',
                'padding-center': '20px',
              }"
          >
            <el-table-column
              align="center"
              sortable
              prop="wo"
              label="WO"
              min-width="118"
            ></el-table-column>
            <el-table-column
              align="center"
              sortable
              prop="entityType"
              label="Type of Device"
              min-width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              sortable
              prop="open"
              label="Open (Days)"
              min-width="140"
            >
              <div slot-scope="{ row }">
                <p v-if="row.open >= 5" style="color: #d525c7">
                  {{ row.open }}
                </p>
                <p v-else>{{ row.open }}</p>
              </div>
            </el-table-column>
            <el-table-column
              align="center"
              prop="priority"
              label="Priority"
              min-width="120"
            >
              <div slot-scope="{ row }">
                <p
                  style="display: inline"
                  v-if="row.priority == 'major' && row.prioritystatus == 1"
                >
                  {{ row.priority }}
                  <el-tooltip placement="top" effect="light">
                    <div slot="content">
                      Action required<br />(Click to respond)
                    </div>
                    <base-button
                      @click="openWarningWindow(row)"
                      class="btn-link"
                      style="display: inline"
                      ><img
                        src="@/assets/img/warning.png"
                        style="display: inline; width: 20px" /></base-button
                  ></el-tooltip>
                </p>
                <p v-else>{{ row.priority }}</p>
              </div>
            </el-table-column>
            <el-table-column
              align="center"
              sortable
              prop="wostatus"
              label="WO Status"
              min-width="153"
            >
              <div slot-scope="{ row }">
                <p v-if="row.wostatus == 'Overdue'" style="color: #d525c7">
                  {{ row.wostatus }}
                </p>
                <p v-else>{{ row.wostatus }}</p>
              </div>
            </el-table-column>
            <el-table-column
              align="center"
              sortable
              prop="contractor"
              label="Contractor"
              min-width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              sortable
              prop="contractorstatus"
              label="Contractor Status"
              min-width="180"
            >
              <div slot-scope="{ row }">
                <p
                  v-if="row.contractorstatus == 'Assigned'"
                  style="color: #15acc9; display: inline"
                >
                  {{ row.contractorstatus }}
                </p>
                <p
                  v-else-if="row.contractorstatus == 'Fix in progress'"
                  style="color: #ffe833; display: inline"
                >
                  {{ row.contractorstatus }}
                </p>
                <p
                  v-else-if="row.contractorstatus == 'Fixed'"
                  style="color: green; display: inline"
                >
                  {{ row.contractorstatus }}
                </p>
                <p
                  v-if="row.contractorstatus == 'Unassigned'"
                  style="color: #ff5733; display: inline"
                >
                  {{ row.contractorstatus }}
                </p>
                <p
                  v-if="row.contractorstatus == 'Verified'"
                  style="color: #d525c7; display: inline"
                >
                  {{ row.contractorstatus }}
                </p>
                <p style="display: inline" v-if="row.progressstatus != ''">
                  <el-tooltip placement="top" effect="light">
                    <div slot="content">
                      Action required<br />(Click to view)
                    </div>
                    <base-button
                      class="btn-link"
                      style="display: inline"
                      @click="openNoti(row.progressstatus)"
                      ><img
                        src="@/assets/img/alert.png"
                        style="display: inline; width: 20px" /></base-button
                  ></el-tooltip>
                </p>
                <p v-else>{{ row.progressstatus }}</p>
              </div>
            </el-table-column>
            <el-table-column align="center" prop="ticketid" min-width="180">
              <div slot-scope="{ row }">
                <base-button
                  class="btn-success"
                  v-if="row.contractorstatus == 'Fixed'"
                  @click="verify(row)"
                >
                  verify
                </base-button>
                <base-button
                  class="btn-success"
                  v-else-if="row.contractorstatus != 'Fixed'"
                  disabled
                >
                  verify
                </base-button>
                <base-button class="btn-success" v-else disabled>
                  verified
                </base-button>
              </div>
            </el-table-column>
            <el-table-column
              label="Edit Form"
              align="center"
              prop="ticketid"
              min-width="160"
            >
              <div slot-scope="{ row }">
                <el-tooltip content="Edit" placement="bottom" effect="light">
                  <base-button
                    class="edit btn-link"
                    type="success"
                    size="sm"
                    icon
                    @click="
                      editWO = row;
                      modals.editForm = true;
                      selects.simple_priority = row.priority;
                      selects.simple_contractor = row.contractor;
                    "
                  >
                    <img src="@/assets/img/edit.png" style="width: 40px" />
                    <!-- <i style="color: #ffffff;" class="tim-icons icon-pencil" aria-hidden="true"></i> -->
                  </base-button>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <modal
        :show.sync="modals.priority"
        footer-classes="justify-content-center"
        type="notice"
      >
        <template slot="header">
          <h3
            class="modal-title"
            id="exampleModalLabel"
            style="color: #ffffff; font-size: 0px"
          >
            <i class="" style="font-size: 20px"></i>
            s
          </h3>
        </template>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12 text-center">
              <img src="@/assets/img/warning.png" style="width: 50px" />
              <p>Contractor has verified this work order as a major issue</p>
              <el-divider></el-divider>
              <p><b>Note:</b> {{ reason }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 text-center">
              <div class="row">
                <div
                  class="col-lg text-center"
                  v-for="item in majorpic"
                  :key="item.id"
                >
                  <img
                    :src="item.src"
                    style="
                      width: 100px;
                      border-radius: 10px;
                      background-color: #be7d7d;
                    "
                  />
                  <!-- position: absolute; -->
                  <p style="left: 80px; bottom: 1px; font-size: 10px">
                    {{ item.details }}
                  </p>
                </div>
              </div>
              <base-button
                class="btn-success"
                @click="changeMajorStatus('approved')"
                >Approved</base-button
              >
              <base-button
                class="btn-danger"
                @click="changeMajorStatus('declined')"
                >Decline</base-button
              >
            </div>
          </div>
        </div>
      </modal>
      <modal
        :show.sync="modals.viewimage"
        footer-classes="justify-content-center"
        type="notice"
        style="z-index: 999"
      >
        <div class="modal-body">
          <div class="row">
            <div class="col-lg">
              <img :src="imagess" />
              <p class="text-center">{{ imagessname }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg text-center">
              <base-button class="btn-warning" @click="modals.viewimage = false"
                >Close</base-button
              >
            </div>
          </div>
        </div>
      </modal>
      <modal
        :show.sync="modals.verifiedform"
        footer-classes="justify-content-center"
        type="notice"
        style="z-index: 1"
      >
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <form @submit.prevent>
                <base-input label="Choose Validation Method">
                  <el-select
                    class="select-primary mb-3 pagination-select"
                    v-model="selects.simple_valid"
                  >
                    <el-option
                      v-for="select in selects.validations"
                      class="select-primary"
                      :value="select.value"
                      :label="select.label"
                      :key="select.label"
                    ></el-option>
                  </el-select>
                </base-input>

                <label for="exampleFormControlTextarea1"
                  >Additional note:</label
                >
                <textarea
                  class="col-lg-12 text-default"
                  style="border: 1px solid #263148"
                  id="xampleFormControlSelect2"
                  rows="3"
                  v-model="additionalNote"
                  placeholder="Please add notes here ..."
                ></textarea>
              </form>
            </div>
          </div>
          <div class="row" style="border: 1px solid #000000; padding: 10px">
            <div class="col-md-12 text-center">
              <h4 class="text-default">Work Order {{ fixed.wo }}</h4>
            </div>
            <div class="col-md-12 text-left">
              <p class="text-default">Light ID : {{ fixed.lightid }}</p>
            </div>
            <div class="col-md-12 text-left">
              <p class="text-default">Location : {{ fixed.location }}</p>
            </div>
            <div class="col-md-12 text-left" style="line-height: 10px">
              <!-- <p class="text-default">{{ fixed.assessment }}</p> -->
              <p class="text-default">{{ fixed.time }}</p>
              <p class="text-default">{{ fixed.date }}</p>
            </div>
            <div class="col-md-12">
              <el-divider></el-divider>
            </div>
            <div class="col-md-12">
              <p>Parts Replaced</p>
              <div class="row" style="margin: 2px">
                <div
                  class="col-lg-6 text-default"
                  style="border: 1px solid #000000"
                >
                  Parts Replaced
                </div>
                <div
                  class="col-lg-6 text-default"
                  style="border: 1px solid #000000"
                >
                  QTY
                </div>
              </div>
              <div
                class="row"
                v-for="item in fixed.partreplaced"
                :key="item.id"
                style="margin: 2px"
              >
                <div
                  class="col-lg-6 text-default"
                  style="border: 1px solid #000000"
                >
                  {{ item.partname }}
                </div>
                <div
                  class="col-lg-6 text-default"
                  style="border: 1px solid #000000"
                >
                  {{ item.qty }}
                </div>
              </div>
              <div class="row">
                <div
                  class="col text-center zoomin"
                  v-for="item in fixed.image"
                  :key="item.id"
                >
                  <img
                    width="100px;"
                    :src="item.img"
                    @click="viewimage(item.img, item.partname)"
                  />
                  <p class="">{{ item.partname }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <form @submit.prevent>
                    <label for="exampleFormControlTextarea1">Root caused</label>
                    <textarea
                      class="col-lg-12 text-default"
                      style="border: 1px solid #000000"
                      id="xampleFormControlSelect2"
                      rows="3"
                      v-model="fixed.assessment"
                      disabled
                    ></textarea>
                    <!-- style="border: 1px solid black" -->
                    <!-- <base-input label="Additional Notes">
                  <textarea class="success" />
                </base-input> -->
                  </form>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <el-checkbox v-model="checked" disabled label="">
                    I/We declare that all information I/We provided <br />above
                    is accurate, complete and true</el-checkbox
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <base-checkbox v-model="tick"
                >I hereby verify that the information above is true and correct
                to the best of my knowledge.
              </base-checkbox>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 text-left">
              <form @submit.prevent>
                <base-button class="btn-warning" @click="reopen()">
                  Re-Open
                </base-button>
              </form>
            </div>
            <div class="col-md-6 text-right">
              <form @submit.prevent>
                <base-button
                  class="btn-success"
                  @click="verified()"
                  :disabled="dis"
                >
                  Verify & close
                </base-button>
              </form>
            </div>
          </div>
        </div>
      </modal>
      <!-- EDIT MODAL -->
      <modal
        :show.sync="modals.editForm"
        footer-classes="justify-content-center"
        type="medium"
      >
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <form @submit.prevent>
                <base-input label="Choose Contractor">
                  <el-select
                    class="select-primary mb-3 pagination-select"
                    v-model="selects.simple_contractor"
                  >
                    <el-option
                      v-for="select in selects.contractors"
                      class="select-primary"
                      :value="select.value"
                      :label="select.label"
                      :key="select.label"
                    ></el-option>
                  </el-select>
                </base-input>
                <!-- <base-input label="Choose Priority">
                  <el-select
                    class="select-primary mb-3 pagination-select"
                    v-model="selects.simple_priority"
                  >
                    <el-option
                      v-for="select in selects.priorities"
                      class="select-primary"
                      :value="select.value"
                      :label="select.label"
                      :key="select.label"
                    ></el-option>
                  </el-select>
                </base-input> -->
              </form>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-center">
              <form @submit.prevent>
                <base-button class="btn-success" @click="editWorkOrder()">
                  Edit
                </base-button>
                <base-button
                  class="btn-success"
                  type="danger"
                  @click.native="modals.editForm = false"
                  >Cancel</base-button
                >
              </form>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import { DoubleBounce } from "vue-loading-spinner";
import { BaseButton, Modal, BaseAlert } from "src/components";
import {
  Table,
  TableColumn,
  Select,
  Option,
  Tooltip,
  Divider,
  Checkbox,
} from "element-ui";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import swal from "sweetalert2";
import moment from "moment";
import BaseCheckbox from "../../components/Inputs/BaseCheckbox.vue";

export default {
  components: {
    Modal,
    Loading,
    DoubleBounce,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    [Tooltip.name]: Tooltip,
    [Divider.name]: Divider,
    [Checkbox.name]: Checkbox,
    BaseButton,
    BaseAlert,
    BaseCheckbox,
  },
  data() {
    return {
      fixed: {
        wo: 1,
        lightid: "PPJ 0017",
        location: "Tamarind Square",
        assessment: "Full tested completed",
        time: "3:30 pm",
        date: "17 March 2021",
        partreplaced: [
          {
            partname: "LED Street Light ",
            qty: 2,
            image: "https://alpha.vectolabs.com:8002/images/28_1627630277.jpg",
          },
          {
            partname: "SPD",
            qty: 1,
            image: "https://alpha.vectolabs.com:8002/images/28_1627630277.jpg",
          },
        ],
        rootcaused: "",
      },
      tickets: [],
      tick: true,
      checked: true,
      dis: false,
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false,
      },
      modals: {
        verifiedform: false,
        editForm: false,
        priority: false,
        classic: false,
        notice: false,
        mini: false,
        viewimage: false,
      },
      imagess: "",
      imagessname: "",
      selects: {
        simple_valid: "",
        validations: [],
        simple_contractor: "",
        contractors: [],
        simple_priority: "",
        priorities: [
          {
            value: "major",
            label: "Major",
          },
          {
            value: "minor",
            label: "Minor",
          },
        ],
      },
      woidAction: "",
      additionalNote: "",
      editWO: "",
      reason:
        "Light pole was hit by a lorry. Require replacement and rewiring.",
      majorpic: [
        {
          id: 1,
          src: require("@/assets/img/lampu.jpg"),
          details: "Faulty lights",
        },
        {
          id: 2,
          src: require("@/assets/img/lampu.jpg"),
          details: "Part installation",
        },
        {
          id: 3,
          src: require("@/assets/img/lampu.jpg"),
          details: "Replaced part",
        },
      ],
      count: "",
      woo: "",
      woid: "",
    };
  },

  methods: {
    openNoti(noti) {
      console.log(noti);
      swal({
        title: "Notification!",
        text: noti,
        type: "info",
      });
    },
    viewimage(img, name) {
      this.modals.viewimage = true;
      this.imagess = img;
      this.imagessname = name;
    },
    changeMajorStatus(data) {
      console.log(data);
      if (data == "approved") {
        swal({
          title: "Are you sure?",
          text: `You want to approved the major status for work order ${this.woid}.`,
          type: "info",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Yes!",
          buttonsStyling: false,
        }).then((result) => {
          this.$http
            .put(":8002/api/v1/work-order/priority/" + this.woid + "/true")
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.getWorkOrderStatus();
                swal({
                  title: "Successfull!",
                  text: `Priority change for work order ${this.woid}.`,
                  type: "success",
                });
                this.modals.priority = false;
              }
            });
        });
      }

      if (data == "declined") {
        swal({
          title: "Are you sure?",
          text: `You want to decline the major status for work order ${this.woid}.`,
          type: "info",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Yes!",
          buttonsStyling: false,
        }).then((result) => {
          this.$http
            .put(":8002/api/v1/work-order/priority/" + this.woid + "/false")
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.getWorkOrderStatus();
                swal({
                  title: "Successfull!",
                  text: `Priority change for work order ${this.woid}.`,
                  type: "success",
                });
                this.modals.priority = false;
              }
            });
        });
      }
    },
    openWarningWindow(data) {
      console.log(data);
      this.reason = data.assessmentnote;
      this.woid = data.id;
      this.majorpic = [];
      this.modals.priority = true;

      // this.$http.put(":8002/api/v1/work-order/priority/" + this.woid + "/" + )

      for (var i = 0; i < data.image.length; i++) {
        let img = data.image[i];

        if (data.image[i] == "") {
          img = require("@/assets/img/no images.png");
        } else {
          // img = process.env.VUE_APP_API_URL +":8002/images/" + data.image[i]
          img = data.image[i];
        }
        let obj = {
          id: i + 1,
          src: img,
          // "https://www.agcled.com/static/blog/led-street-light-04.jpg",
          // src: "https://alpha.vectolabs.com:8002/images/26_1627555875.jpg",
          details: data.details[i],
        };
        this.majorpic.push(obj);
      }
      console.log(this.majorpic);
    },
    test() {
      console.log("saya test function");
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      //   if (rowIndex === 0) {
      return "background-color: #ffffff; color: #000000 !important; border-radius: 10px; border: 2px #263148 solid;";
      //   }
    },
    editWorkOrder() {
      if (this.selects.simple_contractor == this.editWO.contractor) {
        for (let i = 0; i < this.selects.contractors.length; i++) {
          if (
            this.selects.simple_contractor == this.selects.contractors[i].label
          ) {
            this.selects.simple_contractor = this.selects.contractors[i].value;
          }
        }
      }

      let body = {
        // Priority: this.selects.simple_priority,
        ContractorID: this.selects.simple_contractor.toString(),
      };
      console.log(body);
      console.log(this.editWO.id);
      this.$http
        .put(`:8002/api/v1/work-order/status/${this.editWO.id}`, body)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            swal("Edited!", `Work order ${response}`, "success");
            this.modals.editForm = false;
            this.getWorkOrderStatus();
          }
        });
    },
    verify(row) {
      console.log(row);
      this.woidAction = row.id;

      // call data
      this.fixed = [];
      this.$http
        .get(":8002/api/v1/work-order/status/report/" + this.woidAction)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            let part_replaced = [];
            console.log(response.ListReplacement);
            for (var i = 0; i < response.ListReplacement.length; i++) {
              let part = {
                partname: response.ListReplacement[i].PartsName,
                qty: response.ListReplacement[i].Quantity,
              };
              part_replaced.push(part);
            }
            console.log(part_replaced);

            let image = [];
            for (var i = 0; i < response.Images.length; i++) {
              let img = {
                partname: response.Images[i].PartsName,
                img:
                  // process.env.VUE_APP_API_URL +
                  // ":8002/images/" +
                  response.Images[i].ImagePath,
              };
              image.push(img);
            }

            let location = response.DeviceDetail.LocationName;
            if (location == "") {
              location = "-";
            }
            let obj = {
              wo: row.id,
              lightid: response.DeviceDetail.DeviceName,
              location: location,
              assessment: response.DeviceDetail.RootCause,
              time: moment(response.DeviceDetail.EndTime).format("hh:mm a"),
              date: moment(response.DeviceDetail.EndTime).format("DD MMM YYYY"),
              partreplaced: part_replaced,
              image: image,
              rootcaused: response.DeviceDetail.RootCause,
            };
            console.log(obj);
            this.fixed = obj;
            console.log(this.fixed);
          }
        });

      this.modals.verifiedform = true;
    },
    verified() {
      // console.log(this.selects.simple_valid === "");
      console.log(this.selects.simple_valid);
      if (this.selects.simple_valid == "") {
        return swal(
          "Missing validation method!",
          "Please select available validation method.",
          "warning"
        );
      } else {
        let body = {
          IsReopen: false,
          ValidMethodID: this.selects.simple_valid,
          AdditionalNote: this.additionalNote,
        };
        console.log(body);
        this.$http
          .put(":8002/api/v1/work-order/status/verify/" + this.woidAction, body)
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);
              this.modals.verifiedform = false;
              this.getWorkOrderStatus();
              this.selects.simple_valid = "";
              return swal("Verified!", "Work order " + response, "success");
            } else {
              console.log("xbejra");
              console.log(res.message);
            }
          });
      }
    },
    reopen() {
      let body = {
        IsReopen: true,
      };
      this.$http
        .put(`:8002/api/v1/work-order/status/verify/${this.woidAction}`, body)
        .then((res) => {
          if (!res.error) {
            this.selects.simple_valid = "";
            let response = res.message;
            swal("Re-Open!", `Work order ${response}`, "success");
            this.modals.verifiedform = false;
            this.getWorkOrderStatus();
          }
        });
      this.modals.verifiedform = false;
    },
    getWorkOrderStatus() {
      this.$http.get(`:8002/api/v1/work-order/status`).then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          this.tickets = [];

          for (let i = 0; i < response.length; i++) {
            let woStatus = {
              id: response[i].WorkOrderID,
              wo: `${moment(response[i].CreatedAt).format("YYYY-MM-DD")} WO${
                response[i].WorkOrderID
              }`,
              entityType: response[i].EntityTypeName,
              open: response[i].OpenDay,
              priority: response[i].Priority,
              wostatus: response[i].WOStatusName,
              contractor: response[i].ContractorName,
              contractorstatus: response[i].CntrctStatusName,
              reason: response[i].FaultDetails,
              image: response[i].FaultyImage,
              details: response[i].Tag,
              assessmentnote: response[i].AssessmentNote,
              prioritystatus: response[i].PriorityStatus,
              progressstatus: response[i].ProgressStatus,
            };
            this.tickets.push(woStatus);

            console.log(this.tickets);
          }
        }
      });
    },
    getValidMethod() {
      this.$http.get(":8002/api/v1/setting/valid-method").then((res) => {
        if (!res.error) {
          let response = res.message;
          this.selects.validations = [];
          for (let i = 0; i < response.length; i++) {
            let obj = {
              value: response[i].validmethodid,
              label: response[i].methodname,
            };
            this.selects.validations.push(obj);
          }
        }
      });
    },
    getContractor() {
      this.$http.get(":8002/api/v1/contractor").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          this.selects.contractors = [];
          for (let i = 0; i < response.length; i++) {
            let obj = {
              value: response[i].ContractorID,
              label: response[i].ContractorName,
            };
            this.selects.contractors.push(obj);
          }
        }
      });
    },
  },
  mounted() {
    this.getWorkOrderStatus();
    this.getValidMethod();
    this.getContractor();
  },
  computed: {
    // count() {
    //   this.woo = this.$route.params.workorderid
    //   console.log(woo)
    // }
  },
  watch: {
    tick() {
      if (this.tick == false) {
        this.dis = true;
      } else {
        this.dis = false;
      }
    },
    $route(params) {
      console.log(params.params.workorderid);
      if (params.params.workorderid == "all") {
        console.log("all");
      } else {
        console.log("highlight id");
      }
    },
  },
  created() {
    console.log(this.$route.params.workorderid);
    this.woo = this.$route.params.workorderid;
    // this.notifyVue("bottom", "right");
  },
};
</script>
<style scoped>
.row {
  overflow: hidden;
}
.header h3 {
  display: inline;
}
.inlinethings p {
  display: inline;
}
.drawer {
  position: relative;
  height: 97%;
}
#menuButton {
  position: absolute;
  top: 80px;
  left: 6px;
  padding: 10px;
  z-index: 500;
  font-size: 25px;
}
.card .alert {
  position: relative !important;
  width: 100%;
}
/* .gfg {
  margin: 3%;
  position: relative;
}

.first-txt {
  position: absolute;
  bottom: 1px;
  left: 25px;
} */
</style>
